import { useState } from 'react';
import { FormInstance } from 'antd';

import { GenericParam } from '../common/interfaces/commons';

interface Props {
  form: FormInstance<GenericParam>;
}

export const useFormErrorFields = (props: Props) => {
  const { form } = props;

  const [errorFields, setErrorFields] = useState<string[]>([]);

  const extractAndSetErrorFields = () => {
    const errors = form.getFieldsError();
    const errorNames: string[] = errors
      .filter(({ errors }) => errors.length > 0)
      .map(({ name }) => name[0].toString());
      
    setErrorFields(errorNames);
  };
  
  const resetErrorFields = () => {
    setErrorFields([]);
  };

  return {
    errorFields,
    resetErrorFields,
    extractAndSetErrorFields,
  };
};
